<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30.31 30.31" :class="['size', $attrs.class]">
    <path fill="currentColor" d="M17.42 15.16L29.84 2.73c.62-.62.62-1.64 0-2.26s-1.64-.62-2.26 0L15.16 12.89 2.73.47C2.11-.15 1.09-.15.47.47c-.63.62-.63 1.64 0 2.26l12.42 12.42L.47 27.58a1.598 1.598 0 001.13 2.73c.41 0 .82-.16 1.13-.47l12.42-12.42 12.42 12.42c.31.31.72.47 1.13.47a1.598 1.598 0 001.13-2.73L17.41 15.16z"/>
  </svg>
</template>

<script>
import { defineComponent } from 'vue'

export default defineComponent({
  inheritAttrs: false
})
</script>

<style lang="scss" scoped>
.size {
  width: 1em;
  height: 1em;
}
.sm {
  width: 8px !important;
  height: 10px !important;
}
.lg {
  width: 12px !important;
  height: 18px !important;
}
</style>
